import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SyncLog extends DexResourceModel {

    @Field(String)
    public message: string = "";
    @Field(String)
    public jsonData: string = "";

    @Field(String)
    public syncEntity_uuid: string = "";

    @Field(String)
    public syncVendorEntity_uuid: string = "";

    @Field(String)
    public record_uuid: string = "";

    @Field(Boolean)
    public wasSuccessful: boolean | null = false;

    /**
     * These fields come from joins
     */

    @Field(String)
    public clientUuid: string | null = "";

    @Field(String)
    public clientBranchClientId: string | null = "";

    @Field(String)
    public addressUuid: string | null = "";

    @Field(String)
    public syncEntityName: string = "";

    @Field(String)
    public vendorName: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
